import { driveImageUrl } from '../lib/formatters';
import { APP_LOGO_DRIVE_ID } from '../lib/constants';
import { ReplicaSwitcher } from './ReplicaSwitcher';

export function AppHeader({ replica, isAdmin, scopes = [] }) {
  // Aparece pro admin (qualquer cenario) E tambem pra usuario nao-admin
  // que tem mais de uma replica liberada — pra ele poder pular entre as
  // que tem acesso.
  const showReplicaSwitcher = !!isAdmin || (scopes?.length || 0) > 1;
  // Em modo replica: prioridade pra logo da unidade > logo da empresa > app default.
  // Logo de empresa/unidade NAO recebe a classe .app-logo (e asset
  // colorido da marca, nao monocromatico — sem invert filter).
  const unidadeLogo = replica?.unidade?.logo_url;
  const empresaLogo = replica?.empresa?.logo_url;
  const customLogo  = unidadeLogo || empresaLogo;

  const logoSrc = customLogo
    ? driveImageUrl(customLogo)
    : driveImageUrl(APP_LOGO_DRIVE_ID);

  // Titulo no header: prioridade pra unidade > empresa
  let title = 'Notas Fiscais';
  let subtitle = 'ETUS · Comercial × Cobrança';
  if (replica?.isReplica && replica.unidade) {
    title = replica.unidade.nome;
    subtitle = replica.empresa?.nome_fantasia || replica.empresa?.razao_social || 'Faturamento';
  } else if (replica?.isReplica && replica.empresa) {
    title = replica.empresa.nome_fantasia || replica.empresa.razao_social;
    subtitle = replica.config?.label || 'Faturamento';
  }

  return (
    <header style={{
      height: 88,
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      gap: 18,
      padding: '0 28px',
      borderBottom: '1px solid var(--border)',
      background: 'var(--surface)',
      position: 'relative',
      zIndex: 6,
    }}>
      <img
        src={logoSrc}
        alt="Logo"
        className={customLogo ? '' : 'app-logo'}
        referrerPolicy="no-referrer"
        style={{ width: 64, height: 64, objectFit: 'contain' }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
        <span style={{ fontSize: 14.5, fontWeight: 700, color: 'var(--ink)' }}>
          {title}
        </span>
        <span style={{ fontSize: 11.5, color: 'var(--muted)' }}>
          {subtitle}
        </span>
      </div>

      {/* Seletor de replicas aparece pra ADMINs (que tem acesso a todas)
          E pra usuarios com 2+ scopes (que tem acesso a varias mas nao
          todas — precisa pular entre elas). */}
      {showReplicaSwitcher && (
        <div style={{ marginLeft: 'auto' }}>
          <ReplicaSwitcher replica={replica} isAdmin={isAdmin} scopes={scopes} />
        </div>
      )}
    </header>
  );
}
